// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function value_currency_encode(v) {
  return Js_dict.fromArray([
              [
                "currency",
                Decco.stringToJson(v.currency)
              ],
              [
                "minor_amount",
                Decco.intToJson(v.minor_amount)
              ]
            ]);
}

function slab_encode(v) {
  return Js_dict.fromArray([
              [
                "slab_km",
                Decco.intToJson(v.slab_km)
              ],
              [
                "price_per_km",
                value_currency_encode(v.price_per_km)
              ],
              [
                "price_per_min",
                value_currency_encode(v.price_per_min)
              ]
            ]);
}

function last_slab_pricing_request_encode(v) {
  return Js_dict.fromArray([
              [
                "price_per_km",
                value_currency_encode(v.price_per_km)
              ],
              [
                "price_per_min",
                value_currency_encode(v.price_per_min)
              ]
            ]);
}

function slab_pricing_request_encode(v) {
  return Js_dict.fromArray([
              [
                "distance_time_pricing_request",
                Decco.listToJson(slab_encode, v.distance_time_pricing_request)
              ],
              [
                "last_slab_pricing_request",
                last_slab_pricing_request_encode(v.last_slab_pricing_request)
              ]
            ]);
}

function delta_encode(v) {
  return Js_dict.fromArray([
              [
                "base_fare_delta",
                value_currency_encode(v.base_fare_delta)
              ],
              [
                "waiting_rate_per_minute_delta",
                value_currency_encode(v.waiting_rate_per_minute_delta)
              ],
              [
                "free_duration_delta",
                Decco.intToJson(v.free_duration_delta)
              ],
              [
                "free_kms_delta",
                Decco.intToJson(v.free_kms_delta)
              ],
              [
                "free_kms_price_per_min_delta",
                value_currency_encode(v.free_kms_price_per_min_delta)
              ],
              [
                "slab_pricing_request",
                slab_pricing_request_encode(v.slab_pricing_request)
              ]
            ]);
}

function eligibility_config_encode(v) {
  return Js_dict.fromArray([
              [
                "start_time",
                Decco.stringToJson(v.start_time)
              ],
              [
                "end_time",
                Decco.stringToJson(v.end_time)
              ],
              [
                "repeat_on_days",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(Decco.stringToJson, param);
                      }), v.repeat_on_days)
              ],
              [
                "pickup_zone_ids",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(Decco.intToJson, param);
                      }), v.pickup_zone_ids)
              ],
              [
                "drop_zone_ids",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(Decco.intToJson, param);
                      }), v.drop_zone_ids)
              ],
              [
                "pickup_cluster_ids",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(Decco.intToJson, param);
                      }), v.pickup_cluster_ids)
              ],
              [
                "drop_cluster_ids",
                Decco.optionToJson((function (param) {
                        return Decco.listToJson(Decco.intToJson, param);
                      }), v.drop_cluster_ids)
              ]
            ]);
}

function modification_encode(v) {
  return Js_dict.fromArray([
              [
                "type",
                Decco.stringToJson(v.type_)
              ],
              [
                "delta",
                delta_encode(v.delta)
              ]
            ]);
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "name",
                Decco.stringToJson(v.name)
              ],
              [
                "core_campaign_external_id",
                Decco.stringToJson(v.core_campaign_external_id)
              ],
              [
                "start_instant",
                Decco.floatToJson(v.start_instant)
              ],
              [
                "end_instant",
                Decco.optionToJson(Decco.floatToJson, v.end_instant)
              ],
              [
                "modification",
                Decco.listToJson(modification_encode, v.modification)
              ],
              [
                "eligibility_config",
                eligibility_config_encode(v.eligibility_config)
              ]
            ]);
}

export {
  value_currency_encode ,
  slab_encode ,
  last_slab_pricing_request_encode ,
  slab_pricing_request_encode ,
  delta_encode ,
  eligibility_config_encode ,
  modification_encode ,
  t_encode ,
  
}
/* No side effect */
